module.exports = __webpack_public_path__ + "img/shoucang.b5d5b8a0.png";